import { DomusoPropertyProfile } from "./../../types/db-types";

export const getPropertyAddressFromPropertyProfile = (property_profile: DomusoPropertyProfile) => {
  const { postal_code, street_address, city, state } = property_profile;
  return [postal_code, street_address, city, state].join(" ");
};

export const deriveUnitTitle = (property_unit: string | number | null) => {
  return `Unit ${getUnitNumber(property_unit)}`;
};

export const getUnitNumber = (property_unit: string | number | null) => {
  if (property_unit) {
    return `#${property_unit}`;
  }
  return `Unassigned`;
};

export const objectToQueryStringParams = (obj: any) => {
  return Object.keys(obj)
    .reduce((result, key) => {
      return [...result, `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`];
    }, [])
    .join("&");
};

export const boolToHuman = (val: boolean) => val ? "Yes" : "No";

export const DOMUSO_ZEN_DESK_LINK = `https://domusoinc.zendesk.com/hc/en-us`;
export const DOMUSO_ZEN_DESK_LINK_FOR_RESIDENT = "https://domusoinc.zendesk.com/hc/en-us/categories/200399705-Support-for-Residents";
export const DOMUSO_LEGAL_LINK = `https://www.domuso.com/legal`;
export const DOMUSO_PRIVACY_POLICY = `https://www.domuso.com/privacy/`;
export const DEFAULT_TAB_BAR_HEIGHT = 50;
